import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import VueGtag from 'vue-gtag'

import VueCoreVideoPlayer from 'vue-core-video-player'
Vue.use(VueCoreVideoPlayer)

Vue.config.productionTip = false
Vue.use(VueScrollTo);

Vue.use(VueGtag, {
  config: {
    id: 'G-W91RZGJM5M'
  }
}, router)

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')